import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { dealsManager } from '@inpart-io/padme-iap';
import { type IDeal } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

import { actions } from './actions';

const DEAL_MODULE = 'deal';

const dataObjectModule = getDataObjectsModule<IDeal>(dealsManager, 3);
const searchModule = getSearchModule<IDeal>(dealsManager);

const dealModuleInstance = merge<unknown>(dataObjectModule, searchModule, { actions });
store.registerModule(DEAL_MODULE, dealModuleInstance);

export { DEAL_MODULE };
